export const FETCH_LOAN_EMPLOYEES_DDL = "FETCH_LOAN_EMPLOYEES_DDL";
export const FETCH_ASSETS_EMPLOYEES_DDL = "FETCH_ASSETS_EMPLOYEES_DDL";
